/**
 * Setar novo token e datas para cada chamada da API
 * OBS: Para algumas APIs, s� � setado o token, ent�o se o par�metro apiName for vazio, ele s� seta o token e n�o muda as datas
 *
 * @param builder Builder
 * @param actionType Nome do Fetch
 * @param apiName nome do par�metro que vem da API. Se for vazio ele n�o muda as datas
 */
export const fetchFulfilledStateBuilder = (builder, actionType, apiName) => {
    builder.addCase(actionType.fulfilled, (state, action) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (apiName !== '') { // S� muda as datas se passar como par�metro o apiName
            state.recalcular = false;
            if (((_a = action.payload[apiName]) === null || _a === void 0 ? void 0 : _a.obj_datas) &&
                ((_b = action.payload[apiName]) === null || _b === void 0 ? void 0 : _b.obj_datas.data_fim) !== state.dateEnd) {
                state.dateEnd = (_c = action.payload[apiName]) === null || _c === void 0 ? void 0 : _c.obj_datas.data_fim.split('/').join('');
            }
            if (((_d = action.payload[apiName]) === null || _d === void 0 ? void 0 : _d.obj_datas) &&
                ((_e = action.payload[apiName]) === null || _e === void 0 ? void 0 : _e.obj_datas.data_ini) !== state.dateStart) {
                state.dateStart = (_f = action.payload[apiName]) === null || _f === void 0 ? void 0 : _f.obj_datas.data_ini.split('/').join('');
            }
        }
        if (action.payload.access_token && action.payload.expires_in) {
            state.token.value = action.payload.access_token;
            state.token.expiration = action.payload.expires_in * 1000;
            window.localStorage.setItem(`token-${(_h = (_g = window.env) === null || _g === void 0 ? void 0 : _g.REACT_APP_NAME) !== null && _h !== void 0 ? _h : 'comdinheiro'}`, JSON.stringify(Object.assign({}, state.token)));
        }
    });
};
/**
 * Caso do token expirado nas chamadas da API
 * @param builder Builder
 * @param actionType Nome do Fetch
 */
export const fetchRejectedStateBuilder = (builder, actionType) => {
    builder.addCase(actionType.rejected, (state, action) => {
        var _a, _b;
        const payload = action.payload;
        if (payload && (payload === null || payload === void 0 ? void 0 : payload.codigo) === '5c32fa')
            state.unauthorized = true;
        if (payload && ((payload === null || payload === void 0 ? void 0 : payload.msg) === 'Expired token' || (payload === null || payload === void 0 ? void 0 : payload.codigo) === '416ee6')) { // 416ee6 indica jwt invalido
            window.localStorage.removeItem(`token-${(_b = (_a = window.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_NAME) !== null && _b !== void 0 ? _b : 'comdinheiro'}`);
            window.localStorage.removeItem('preferenceStyle');
            state.token.value = '';
        }
    });
};
